import React from "react";

// Warranty status badge — used on VR list rows, VR detail sticky header,
// SOM header (when linked to a VR), and customer profile vehicles tab.
export default function WarrantyStatusBadge({ status, daysToExpiry, size = "sm", testid }) {
  const cfg = {
    active: { label: "Garantia activa", color: "bg-[#D1F2E1] text-[#0F5132] border-[#28A745]/40" },
    expiring_soon: { label: "Garantia expira em breve", color: "bg-[#FFF7E6] text-[#856404] border-[#FFC107]/50" },
    expired: { label: "Garantia expirada", color: "bg-[#F8D7DA] text-[#721C24] border-[#DC3545]/40" },
    unknown: { label: "Garantia — sem informação", color: "bg-gray-100 text-gray-600 border-gray-300" },
  }[status || "unknown"];
  const sizeCls = size === "lg"
    ? "text-xs px-2 py-0.5"
    : "text-[10px] px-1.5 py-0.5";
  return (
    <span
      data-testid={testid || `warranty-badge-${status}`}
      className={`inline-flex items-center gap-1 font-semibold uppercase tracking-wider border rounded-sm ${sizeCls} ${cfg.color}`}
    >
      {cfg.label}
      {daysToExpiry != null && status !== "expired" && (
        <span className="font-mono normal-case tracking-normal opacity-80">· {daysToExpiry}d</span>
      )}
      {daysToExpiry != null && status === "expired" && (
        <span className="font-mono normal-case tracking-normal opacity-80">· há {Math.abs(daysToExpiry)}d</span>
      )}
    </span>
  );
}
